webpackJsonp([56],{

/***/ "dYBL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-current-plan_30a55753e41924c70d85596ae76989fc.html";

/***/ }),

/***/ "x7II":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var underscore_extensions_1 = __webpack_require__("R0iF");
var CURRENT_PLAN_NAME = 0;
var SubscriptionCurrentPlan = (function () {
    SubscriptionCurrentPlan.$inject = ["subscriptionSvc"];
    function SubscriptionCurrentPlan(subscriptionSvc) {
        this.subscriptionSvc = subscriptionSvc;
        this.productName = underscore_extensions_1.Utils.getProduct().toLocaleLowerCase();
        this.planDisplayName = this.planName.split(' ')[CURRENT_PLAN_NAME];
    }
    SubscriptionCurrentPlan.prototype.$onChanges = function () {
        this.planNameText = this.capitalize(this.planName.toLocaleLowerCase());
    };
    SubscriptionCurrentPlan.prototype.capitalize = function (text) {
        var textArr = text.split(' ');
        return textArr.reduce(function (initText, word) { return initText + " " + Strings_1.Strings.capitalize(word); }, '');
    };
    return SubscriptionCurrentPlan;
}());
angular
    .module('animatronApp.SubscriptionCurrentPlan', [])
    .component('subscriptionCurrentPlan', {
    bindings: {
        planName: '<',
        nextPaymentValue: '<',
        nextPaymentDate: '<',
        switchPeriod: '<',
        expirationDate: '<',
        switchSave: '<',
        onSwitchTo: '&?',
        onCancel: '&?'
    },
    controller: SubscriptionCurrentPlan,
    templateUrl: __webpack_require__("dYBL")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/56-c7c98a0cc108ea8b91f3.min.js